// Instant re-open for chart loads (EHI Bridge guide §3.2).
// Caches the chart-by-id response per chart_uuid (in memory, this tab session only — no
// PHI persisted to storage) and sends If-None-Match on the next load; an unchanged chart
// comes back 304 with no body, so re-opening is instant.
// recent_months (§3.1) is intentionally not used — opt-in, off for now.
//
// In-flight requests are de-duped per uuid: React's dev double-invoke (or two surfaces
// racing the same chart) fire a single network request and agree on one cached/fresh
// result, so a re-open is deterministically a 304 cache hit rather than flaky.
const cache = {};
const inflight = {};

async function doFetch(proxyBase, uuid, token) {
  const url = `${proxyBase}/api/ehibridge/import/chart-by-id/${encodeURIComponent(uuid)}`;
  const headers = { Accept: "application/json", Authorization: `Bearer ${token}` };
  const cached = cache[uuid];
  if (cached && cached.etag) headers["If-None-Match"] = cached.etag; // compare as-is (W/"…")
  // no-store: let our manual If-None-Match reach the server for a clean 304 (never a stale browser-cache 200).
  const res = await fetch(url, { headers, cache: "no-store" });
  if (res.status === 304 && cached) return { data: { ...cached.body }, cached: true }; // instant, no payload
  if (!res.ok) throw new Error("HTTP " + res.status);
  const body = await res.json();
  const etag = res.headers.get("etag");
  if (etag) cache[uuid] = { etag, body };
  return { data: { ...body }, cached: false };
}

export async function fetchChartById(proxyBase, uuid, token) {
  if (inflight[uuid]) return inflight[uuid];
  const p = doFetch(proxyBase, uuid, token);
  inflight[uuid] = p;
  try { return await p; } finally { delete inflight[uuid]; }
}
